import { render, staticRenderFns } from "./OpaqueCardHeaderWithTabs.vue?vue&type=template&id=7bef7d84&scoped=true&"
import script from "./OpaqueCardHeaderWithTabs.vue?vue&type=script&lang=js&"
export * from "./OpaqueCardHeaderWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./OpaqueCardHeaderWithTabs.vue?vue&type=style&index=0&id=7bef7d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef7d84",
  null
  
)

export default component.exports